import { useReducer } from 'react'

const reducer = (state: any) => !state
export const useForceUpdate = () => {
  const [, dispatch] = useReducer(reducer, false)
  return dispatch
}
